import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { Ab } from '@df/module-ab/ab.namespace';
import { AbService } from '@df/module-ab/ab.service';
import { AB_OPTIONS } from '@df/module-ab/ab.tokens';

/**
 * @usage Angular 18+
 *
 * ```ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideDfModuleAb()
 *   ]
 * };
 */
export function provideDfModuleAb(options?: Partial<Ab.IOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: AB_OPTIONS,
            useValue: options
        },
        provideAppInitializer(() => {
            inject(AbService).appInitialize();
        })
    ]);
}
